import { getAddressURL } from 'src/constants/BlockchainConstants'
import { useAppSelector } from 'src/store/store'
import { maskHash } from 'src/constants/ConversionUtils'
import { CopyLink } from 'src/components/shared/CopyLink'

type Props = {
  blockchain: string
  address: string
  shouldTruncate?: boolean
  truncateAmount?: number
  className?: string
}

export const ExplorerAddressLink: React.FC<Props> = ({
  blockchain,
  address,
  shouldTruncate = false,
  truncateAmount = 6,
  className,
}) => {
  const selector = useAppSelector
  const network = selector((state) => state.NetworkReducer.network)
  if (!address || !blockchain) {
    return <div>{'-'}</div>
  }

  // link to transactions page in respective explorers
  const explorerUrl = getAddressURL(blockchain, address, network)
  if (!explorerUrl) {
    return <div>{address} (Link not found)</div>
  }

  const formattedHash = shouldTruncate ? maskHash(address, truncateAmount) : address
  return <CopyLink copyText={address} text={formattedHash} url={explorerUrl} className={className}/>
}
